// @flow
import productMappings from 'constants/productNameMappings';

export const internalToOfficial = (internalProductName: string): string => {
	const product = productMappings.find(p => p.internal === internalProductName);
	return product ? product.official : internalProductName;
};
